import _ from 'lodash';
import getAppointmentFieldSection from './sections/appointmentFieldSection';

export default (editorAPI: AnyFixMe) => {
  const appointmentFieldSection = getAppointmentFieldSection(editorAPI);

  return _.merge({}, appointmentFieldSection);
};
